import {
  FETCH_DISPUTES,
  FETCH_DISPUTES_SUCCESS,
  FETCH_DISPUTES_FAILED
} from '../../types';

const initialState = {
  disputes: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchDisputesReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DISPUTES:
      return {
        ...state,
        isLoading: true,
          disputes: action.payload
      }
      case FETCH_DISPUTES_SUCCESS:
        return {
          ...state,
          isLoading: false,
            disputes: action.payload
        }
        case FETCH_DISPUTES_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchDisputesReducer;
